import { render, staticRenderFns } from "./OpenShow.vue?vue&type=template&id=3494d82a&scoped=true&"
import script from "./OpenShow.vue?vue&type=script&lang=js&"
export * from "./OpenShow.vue?vue&type=script&lang=js&"
import style0 from "./OpenShow.vue?vue&type=style&index=0&id=3494d82a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3494d82a",
  null
  
)

export default component.exports